module.exports = __webpack_public_path__ + "static/media/softwareFeat.b120938e.jpg";